import {Kachel} from "../structs/Kachel";

export interface IKachelOverlay extends google.maps.OverlayView {
    readonly latlng: google.maps.LatLng;
    readonly kachel: Kachel;
    readonly mapDiv: JQuery<HTMLElement>;
    readonly map: google.maps.Map;

    div: JQuery<HTMLElement> | null;
    width: number;
    height: number;

    draw(): void;
    remove(): void;
}

let kachelIncZ = 100;

export function frontIndexZ(div: JQuery<HTMLElement>, extraOffset?: number) {
    if (!extraOffset) extraOffset = 0;
    div.css({'z-index': (kachelIncZ++) + extraOffset});
    return div;
}
